import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';

export const StyledLoadingButton = styled(LoadingButton)(
  () => `
  height: 48px;
  background-color: '#4a4f7f';
`,
);
